// @ts-nocheck
import {FC} from 'react'
import {ColumnInstance} from 'react-table'

type Props = {
  column: ColumnInstance<any>
}

export const ColumnHeader: FC<Props> = ({column}) => (
  <>
    {column.Header && typeof column.Header === 'string' ? (
      <th
        {...column.getHeaderProps()}
        className='px-4 py-3 text-left text-sm font-semibold text-white bg-[#008080] uppercase tracking-wide'
      >
        {column.render('Header')}
      </th>
    ) : (
      column.render('Header')
    )}
  </>
)
